<template>
<div v-if="model.field_type == null">
    <div
      ref="menu"
      class="tippy-wrapper flex flex-row justify-center items-center"
    >

      <div class="outer__menu flex flex-row">
        <div @click="closeMenu" v-tooltip="'Close Menu'">
          <svg-icon
            icon="heroicons/outline/x"
            class="h-8 w-8 cursor-pointer p-1 text-gray-500 bg-gray-200 hover:bg-gray-300 rounded-full ml-2"
          />
        </div>

        <div @click="$emit('delete-content', model)">
          <svg-icon
            icon="heroicons/outline/trash"
            class="h-8 w-8 cursor-pointer p-1 text-gray-500 bg-gray-200 hover:bg-gray-300 rounded-full ml-2"
            v-tooltip="'Delete field'"
          />
        </div>
      </div>
    </div>

  <div ref="target" class="bg-white border border-solid border-gray-300 shadow-md rounded p-2  mx-auto">

          <div class="flex flex-row mx-auto">
            <div class="my-auto text-base text-blue-700 ml-4 mr-4">Select input type:</div>

            <div
              class="border border-solid border-gray-200 cursor-pointer mr-5 p-1 bg-white rounded flex flex-col items-center justify-center hover:shadow-md"
              @click="setFieldType('email')"
              v-tooltip="'Email'"
            >
              <div
                class="text-blue-400 p-1 flex flex-col justify-center items-center"
                :class="{ 'bg-blue-100': hover == 'email' }"
              >
                <span class="material-icons">
                  email
                </span>
              </div>

            </div>

            <div
              class="border border-solid border-gray-200 cursor-pointer p-1 mr-5 bg-white rounded flex flex-col items-center hover:shadow-md"
              @click="setFieldType('url')"
              v-tooltip="'Website'"
            >
              <div
                class="text-blue-400 p-1 flex flex-col justify-center items-center"
                :class="{ 'bg-blue-100': hover == 'url' }"
              >
                <span class="material-icons">
                  language
                </span>
              </div>
            </div>

            <div
              class="border border-solid border-gray-200 cursor-pointer p-1 mr-5 bg-white rounded flex flex-col items-center hover:shadow-md"
              @click="setFieldType('text')"

              v-tooltip="'Short Text'"
            >
              <div
                class="text-blue-400 p-1 flex flex-col justify-center items-center"
                :class="{ 'bg-blue-100': hover == 'text' }"
              >
                <span class="material-icons">
                  horizontal_rule
                </span>
              </div>

            </div>
          </div>

  </div>
  </div>
  <div v-else>
    <!-- The bubble menu -->
    <div
      ref="menu"
      class="tippy-wrapper flex flex-row justify-center items-center"
    >
      <div
        class="bubble-menu bg-white rounded-lg mb-1 p-1 flex flex-row justify-center shadow-lg"
      >

        <div
          class="font__setter flex flex-row h-9">

            <input
            class="w-38 px-2 border border-solid border-gray-200 rounded text-gray-400"
            v-model="placeholder"
            style="font-family: 'Roboto', san-serif"
            v-tooltip="'Placeholder text'"
          />
          </div>


          
        <div
          class="font__setter flex flex-row h-9 m-auto rounded"
          style="border: 1px solid rgba(57,76,96,.15);"
        >

          <div
            class="w-6 text-center cursor-pointer flex flex-row justify-center"
            @click="subtractFont"
            v-tooltip="'Increase Font'"
          >
            <svg-icon
              icon="heroicons/solid/minus"
              class=" w-4 h-4 p-0 m-auto text-gray-500 cursor-pointer "
            />
          </div>
          <input
            class="w-8 border-l border-r border-solid border-gray-200 text-center text-gray-600"
            v-model="fontSize"
            style="font-family: 'Roboto', san-serif"
            v-tooltip="'Font Size'"
          />
          <div
            class="w-6 text-center cursor-pointer flex flex-row justify-center"
            @click="addFont"
            v-tooltip="'Decrease Font'"
          >
            <svg-icon
              icon="heroicons/solid/plus"
              class=" w-4 h-4 p-0 m-auto text-gray-500 cursor-pointer "
            />
          </div>
        </div>

        <!-- Color Picker start -->
        <!--
        <BasePopover :showPopover="colorSettings">
          <template v-slot:button>
            <button
              class="menu flex flex-col items-center justify-center relative"
              style="padding:0px"
              v-tooltip="'Colors'"
              @click="colorSettings = true"
              :style="{
                background: model.bgColor,
                border: '1px solid ' + model.borderColor,
                'box-shadow': 'none',
              }"
            >
              <span class="material-icons" :style="{ color: color }">
                font_download
              </span>
            </button>
          </template>

          <template v-slot:body>
            <div
              id="button-settings"
              class=" bg-gray-800 rounded mt-2 z-10 inline-block text-left pl-3 pb-3"
              style="right: 0%;"
            >
              <div class="flex flex-row-reverse">
                <div @click="closecolorSettings">
                  <svg-icon
                    icon="heroicons/outline/x"
                    class="w-3 h-3 text-gray-400 hover:text-gray-300 font-bold mt-2 mr-2 cursor-pointer"
                  />
                </div>
              </div>

              <div class="pr-3">
                <ul class="flex mb-0 list-none flex-wrap pt-0 pb-4 flex-row">
                  <li class="-mb-px pr-1 mr-2 last:mr-0 flex-auto text-center">
                    <a
                      class="text-xs font-bold uppercase py-1 block leading-normal hover:no-underline"
                      v-on:click="toggleTabs(1)"
                      v-bind:class="{
                        'text-gray-400 hover:text-gray-300 cursor-pointer':
                          openTab !== 1,
                        'text-gray-400 hover:text-gray-300 border-b-2 border-blue-500 cursor-pointer ':
                          openTab === 1,
                      }"
                    >
                      Background
                    </a>
                  </li>
                  <li class="-mb-px mr-2 pr-1 last:mr-0 flex-auto text-center">
                    <a
                      class="text-xs font-bold uppercase py-1 block leading-normal hover:no-underline"
                      v-on:click="toggleTabs(2)"
                      v-bind:class="{
                        'text-gray-400 hover:text-gray-300 cursor-pointer':
                          openTab !== 2,
                        'text-gray-400 hover:text-gray-300 border-b-2 border-blue-500 cursor-pointer ':
                          openTab === 2,
                      }"
                    >
                      Text
                    </a>
                  </li>

                  <li class="-mb-px mr-2 pr-1 last:mr-0 flex-auto text-center">
                    <a
                      class="text-xs font-bold uppercase py-1 block leading-normal hover:no-underline"
                      v-on:click="toggleTabs(3)"
                      v-bind:class="{
                        'text-gray-400 hover:text-gray-300 cursor-pointer':
                          openTab !== 3,
                        'text-gray-400 hover:text-gray-300 border-b-2 border-blue-500 cursor-pointer':
                          openTab === 3,
                      }"
                    >
                      Border
                    </a>
                  </li>
                </ul>

                <div v-if="openTab == 1" class="">
                  <verte
                    model="hex"
                    v-model="bgColor"
                    display="widget"
                    :enableAlpha="false"
                    :showHistory="false"
                  >
                    <div
                      class="h-5 w-5 border border-solid border-white ml-2"
                      :style="{ background: bgColor }"
                    ></div>
                  </verte>
                </div>

                <div v-if="openTab == 2" class="">
                  <verte
                    model="hex"
                    v-model="color"
                    display="widget"
                    :enableAlpha="false"
                    :showHistory="false"
                  >
                    <div
                      class="h-5 w-5 border border-solid border-white ml-2"
                      :style="{ background: color }"
                    ></div>
                  </verte>
                </div>

                <div v-if="openTab == 3" class="">
                  <verte
                    model="hex"
                    v-model="borderColor"
                    display="widget"
                    :enableAlpha="false"
                    :showHistory="false"
                  >
                    <div
                      class="h-5 w-5 border border-solid border-white ml-2"
                      :style="{ background: borderColor }"
                    ></div>
                  </verte>
                </div>
              </div>
            </div>
          </template>
        </BasePopover>
        -->

         <div
          class="font__setter flex flex-row h-9">

            <input
            class="w-20 px-2 border border-solid border-gray-200 rounded text-gray-400"
            v-model="name"
            style="font-family: 'Roboto', san-serif"
            v-tooltip="'Field name'"
          />
          </div>

        <button class="menu" v-tooltip="'Clone Field'" @click="copyContent">
          <span class="material-icons">
            content_copy
          </span>
        </button>  

        <BasePopover :showPopover="showPaddingPopover">
          <template v-slot:button>
            <button
              class="menu flex flex-col items-center justify-center relative"
              @click="showPaddingPopover = true"
              :style="{ padding: '0px' }"
              v-tooltip="'More'"
            >
              <span class="material-icons">
                more_horiz
              </span>
            </button>
          </template>

          <template v-slot:body>
            <div
              id="button-settings"
              class="bg-white border border-solid border-gray-300 shadow-lg rounded mt-2 z-10 inline-block text-left pl-3 pb-1"
              style="right: 0%;"
            >
              <div class="flex flex-row-reverse">
                <div @click="showPaddingPopover = false">
                  <svg-icon
                    icon="heroicons/outline/x"
                    class="w-3 h-3 text-gray-400 hover:text-gray-300 font-bold mt-2 mr-2 cursor-pointer"
                  />
                </div>
              </div>

              <div
                class="pr-3 flex mb-0 list-none flex-wrap pt-0 pb-1 flex-row"
              >
                <table>
                  <tbody>
                    <tr>
                      <td class="pr-6 py-1"></td>
                      <td class="pr-5 py-1 text-center text-xs text-gray-600">
                        X-axis
                      </td>
                      <td class="py-1 text-center text-xs text-gray-600">
                        Y-axis
                      </td>
                    </tr>
                    <tr>
                      <td class="pr-3 py-1 text-xs">Padding</td>
                      <td class="pr-5 py-1">
                        <input
                          v-model="paddingX"
                          class="text-center w-8 h-8 rounded border border-solid border-gray-300"
                        />
                      </td>
                      <td class="py-1">
                        <input
                          v-model="paddingY"
                          class="text-center w-8 h-8 rounded border border-solid border-gray-300"
                        />
                      </td>
                    </tr>

                    <tr>
                      <td class="pr-3 py-1 text-xs">Border Radius</td>
                      <td class="pr-5 py-1">
                        <input
                          v-model="borderRadius"
                          class="text-center w-8 h-8 rounded border border-solid border-gray-300"
                        />
                      </td>

                      <td class="py-1"></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </template>
        </BasePopover>
      </div>

      <div class="outer__menu flex flex-row">
        <div @click="closeMenu" v-tooltip="'Close Menu'">
          <svg-icon
            icon="heroicons/outline/x"
            class="h-8 w-8 cursor-pointer p-1 text-gray-500 bg-gray-200 hover:bg-gray-300 rounded-full ml-2"
          />
        </div>

        <div @click="$emit('delete-content', model)">
          <svg-icon
            icon="heroicons/outline/trash"
            class="h-8 w-8 cursor-pointer p-1 text-gray-500 bg-gray-200 hover:bg-gray-300 rounded-full ml-2"
            v-tooltip="'Delete field'"
          />
        </div>
      </div>
    </div>

    <!-- The actual input field starts here -->

    <div ref="target" class="handle">
      <input
        class="flex-1 appearance-none border border-transparent w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-md rounded-lg text-base focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent"
        :type="model.field_type"
        :placeholder="placeholder"
        disabled="true"
        :name="model.name"
        :style="{
          'font-family': survey.fontFamily,
          'border-color': borderColor,
          'background-color': bgColor,
          'border-radius': borderRadius + 'px',
          'font-size': fontSize + 'px',
          padding: paddingY + 'px ' + paddingX + 'px',
        }"
      />
    </div>
  </div>
</template>

<script>
import FormField from "@/models/content/FormField";
//import Content from "@/models/content/Content";
import tippy from "tippy.js";

//Verte Color Picker
//https://baianat.github.io/verte/guide/
//import Verte from "verte";
//import "verte/dist/verte.css";

export default {
  name: "input-field",
  components: {
    //EditorContent,
    //Verte,
  },
  data() {
    return {
      bubbleMenu: null,
      colorSettings: false,
      showPaddingPopover: false,
      hover: false,
    };
  },
  props: ["content_id", "survey", "step"],
  computed: {
    cssVars() {
      return {
        "--text-color": this.color,
        "--font-size": this.fontSize + "px",
        "--font-family": this.survey.fontFamily,
      };
    },

    model() {
      return FormField.find(this.content_id);
    },

    placeholder:{
      get(){
  
      let ph = (this.model.field_type == 'email') ? "Enter your email" : (this.model.field_type == 'url') ? "Enter website url" : "Enter your text";

      return this.model.text ?? ph;

      },
      set(value){
        FormField.update({
          where: this.content_id,
          data: { text: value },
        });

      }
    },

    color: {
      get() {
        return this.model.fontColor;
      },
      set(col) {
        FormField.update({
          where: this.content_id,
          data: { fontColor: col },
        });
      },
    },

    name: {
      get() {
        return this.model.name;
      },
      set(value) {
        FormField.update({
          where: this.content_id,
          data: { name: value },
        });
      },
    },

    fontSize: {
      get() {
        return this.model.fontSize;
      },
      set(num) {
        FormField.update({
          where: this.content_id,
          data: { fontSize: num },
        });
      },
    },

    bgColor: {
      get() {
        return this.model.bgColor;
      },
      set(value) {
        if (value !== this.model.bgColor) {
          FormField.update({
            where: this.model.id,
            data: { bgColor: value },
          });
        }
      },
    },
    borderColor: {
      get() {
        return this.model.borderColor;
      },
      set(value) {
        if (value !== this.model.borderColor) {
          FormField.update({
            where: this.model.id,
            data: { borderColor: value },
          });
        }
      },
    },
    borderRadius: {
      get() {
        return this.model.borderRadius;
      },
      set(value) {
        if (value !== this.model.borderRadius) {
          FormField.update({
            where: this.model.id,
            data: { borderRadius: value },
          });
        }
      },
    },
    paddingX: {
      get() {
        return this.model.paddingX;
      },
      set(value) {
        if (value !== this.model.paddingX) {
          FormField.update({
            where: this.model.id,
            data: { paddingX: value },
          });
        }
      },
    },
    paddingY: {
      get() {
        return this.model.paddingY;
      },
      set(value) {
        if (value !== this.model.paddingY) {
          FormField.update({
            where: this.model.id,
            data: { paddingY: value },
          });
        }
      },
    },
    goto: {
      get() {
        return this.model.goto;
      },
      set(value) {
        if (value !== this.model.goto) {
          FormField.update({ where: this.model.id, data: { goto: value } });
        }
      },
    },
    gotoLink: {
      get() {
        return this.model.goto_link;
      },
      set(value) {
        if (value !== this.model.goto_link) {
          FormField.update({
            where: this.model.id,
            data: { goto_link: value },
          });
        }
      },
    },
  },
  methods: {
    toggleTabs: function(tabNumber) {
      this.openTab = tabNumber;
    },
    addFont() {
      this.fontSize++;
    },
    subtractFont() {
      this.fontSize--;
    },
    setAlign(dir) {
      this.$emit("set-align", dir);
    },
    setFieldType(type){

      let name = "";

      if (type =='email') name = "email";
      else if (type == 'url') name = "website";
      else name = "field1"

        FormField.update({
          where: this.model.id,
          data: { field_type: type, name: name },
        });

        this.bubbleMenu.hide();

    },
    deleteContent() {
      //await Button.delete(this.model.id);
      this.$emit("delete-content", this.model);
    },
    copyContent() {
      this.$emit("copy-content", this.model);
      /*
      const clone = await FormField.clone(this.model);
      //clone.column_id = this.column.id;
      FormField.insert({
        data: clone
      });
      */
    },
    closeMenu(event) {
      //Close BubbleMenu created by Tippy.js directly (w/o editor)
      this.bubbleMenu.hide();
      this.closecolorSettings(event);
    },

    closecolorSettings(event) {
      //Close Button Setting dropdown
      event.stopPropagation();
      this.colorSettings = false;
    },
  },

  mounted() {
    let target = this.$refs.target;
    let menu = this.$refs.menu;

    this.bubbleMenu = tippy(target, {
      content: menu,
      interactive: true,
      duration: 10,
      maxWidth: "none",
      hideOnClick: false,
      trigger: "click",
      onClickOutside(instance, event) {
        instance.hide();
      },
    });
  },

  destroyed() {
    window.removeEventListener("keydown", this.onEscape);
  },
};
</script>

<style></style>
